import { Controller } from "@hotwired/stimulus";
import IMask from "imask";

export default class extends Controller {
  static targets = ["format"];

  formatTargetConnected(target) {
    const mask = IMask(target, {
      mask: target.dataset.inputMaskFormat,
      lazy: false,
      blocks: {
        money: {
          mask: Number,
          scale: 2,
          thousandsSeparator: "",
          padFractionalZeros: true,
          radix: "."
        },
        monthYear: {
          mask: "MM/YYYY",
          lazy: false,
          blocks: {
            MM: {
              mask: IMask.MaskedRange,
              from: 1,
              to: 12,
              maxLength: 2,
              placeholderChar: "M"
            },
            YYYY: {
              mask: IMask.MaskedRange,
              from: 2024,
              to: 2099,
              placeholderChar: document.body.dataset.locale === "fr" ? "A" : "Y"
            }
          }
        },
        anything: {
          mask: /(.*?)/
        }
      }
    });

    const updateValidity = () => {
      if (mask.value && !mask.masked.isComplete) {
        target.setCustomValidity("invalid");
      } else {
        target.setCustomValidity("");
      }
    };

    mask.on("accept", updateValidity);
    mask.on("complete", updateValidity);
  }
}
